import { Flex, Box } from "@chakra-ui/react"

export default function Wrapper({ children, id = null, fullWidth = false, ...rest }) {
    return (
        <Flex
            className="pageWrapper__outer scroll-offset"
            direction="column"
            w="100%"
            align="center"
            bgSize="cover"
            px="30px"
            {...rest}
        >
            <Box id={id} className="pageWrapper__inner scroll-offset" w="100%" maxW={fullWidth ? "none" : { xl: 1200 }}>
                {children}
            </Box>
        </Flex>
    )
}
